import React from 'react';
import compose from '../../utils/compose'
import {OrderMessages} from '../../utils/constUtils'
import withNofeshService  from '../../hoc/withNofeshService.hoc';
import Spinner from 'react-bootstrap/Spinner'

class ModalOrder extends React.Component {

    timer = 0;

    state = {
        loading:false,
        IsCouplingRooms:false,
        HasConnectionDoor:false,
        timeEnded:false,
        time: {},
        //seconds: 300, 
        seconds: window.NOFESH_PLACE_ORDER_TIMEOUT_SEC, 
        errorMsg:'',
        timeMsg:'הזמן שנותר לביצוע ההזמנה',
        placeOrderData : {}

    }

    getFormattedMin() {
        if (this.state.time.m < 10) {
            return "0" + this.state.time.m;
        } else {
            return this.state.time.m;
        }
    }
    
    getFormattedSec() {
        if (this.state.time.s < 10) {
            return "0" + this.state.time.s;
        } else {
            return this.state.time.s;
        }
    }

    secondsToTime(secs) {
        let hours = Math.floor(secs / (60 * 60));
        let divisor_for_minutes = secs % (60 * 60);
        let minutes = Math.floor(divisor_for_minutes / 60);

        let divisor_for_seconds = divisor_for_minutes % 60;
        let seconds = Math.ceil(divisor_for_seconds);

        let obj = {
            "h" : hours,
            "m" : minutes,
            "s" : seconds
        };
        return obj;
        
    }

    countDown = () => {
        const { nofeshService } = this.props;
        const { placeOrderData } = this.props;
        const { personData } = this.props;
        

        let seconds = this.state.seconds  -1;
        this.setState({
            time: this.secondsToTime(seconds),
            seconds: seconds        
        });

        // check if ended
        if (seconds == 0) {
            console.log('time is out!')
            clearInterval(this.timer);

            
            nofeshService.placeOrderRemove(

                placeOrderData.hotelForOrder.AllocationId).then( res  => {    
          
                console.log('ResultsPage componentDidMount getSearchHotelsForOrder res.data: ', res.data);
                //let  resultObj = res.data;

                this.setState({ 
                    timeMsg:'',
                    errorMsg: OrderMessages.timeOut,
                    timeEnded: true
                });          
            }); 
        }
    }

    startTimer = () => {
        if (this.timer == 0 && this.state.seconds > 0) {
            this.timer = setInterval(this.countDown, 1000);
        }
    }

    componentDidMount() {
        window.scrollTo({
            top: 0,
            behavior: "smooth"
            });

              
        const {placeOrderData} = this.props;
        this.setState({placeOrderData: placeOrderData});

        let timeLeftVar = this.secondsToTime(this.state.seconds);
        this.setState({time: timeLeftVar});
        this.startTimer();
    }



    HasConnectionDoorChange = e => {
        console.log('e.currentTarget.value', e.currentTarget.value);
        let t = this.state.HasConnectionDoor;
        this.setState( {HasConnectionDoor:!t} );
    };


    CouplingRoomsChange = e => {
        let t = !this.state.IsCouplingRooms;
        this.setState( {IsCouplingRooms:t} );
        console.log('CouplingRoomsChange t', t);
    };


    doOrder = () => {


        
        this.setState({ loading: true});
        if (this.state.timeEnded) {
            this.props.setModalOrderClosed(this.props.placeOrderData);
            return;
        }

        
        if( this.state.loading) {
            console.log('doOrder clicked');
            return;
        }

        let { placeOrderData } = this.props;
        placeOrderData.HasConnectionDoor = this.state.HasConnectionDoor;
        placeOrderData.IsCouplingRooms = this.state.IsCouplingRooms;

        this.props.doOrder(this.props.placeOrderData);
    }


    setModalOrderClosed = () =>  {
        if( this.state.loading) {
            return;
        }
        this.props.setModalOrderClosed(this.props.placeOrderData);
    }

  render() {
    const { placeOrderData } = this.props;
    const hotelForOrder  = placeOrderData.hotelForOrder;

    return (

            <div className="cntered-flex">
                <React.Fragment >      
                    <div className="modal_main_bg" ></div>
                    <div className="cntered-flex">
                        <div className="modal_order_bg_2">

                            <div className="close_arrow pointer zindex1000" onClick={this.setModalOrderClosed}></div>

                            <div className="modal_order_inner_bg">
                                <div className="modal_order_top">                            
                                    <div className="modal_order_title1">
                                    

                                    אישור הזמנה
                                    </div>
                                    
                                </div>
                                <div className="modal_order_title_hotel">
                                    מלון
                                    &nbsp;
                                    {hotelForOrder.HotelName}

                                </div>
                                <div className="cntered-flex">
                                    <div className="modal_order_title_second">
                                        <span> {this.state.timeMsg}</span>
                                        <span className="modal_order_err1"> {this.state.errorMsg}</span>
                                    </div>
                                    
                                </div>
                                <div className="cntered-flex">
                                    <div className="modal_order_title_second_time clearBoth">
                                        {this.getFormattedMin()} : {this.getFormattedSec()}
                                        
                                    </div>
                                </div>

                                <div className="modal_order_grid_container">
                                    <div className="modal_order_grid_inner_container directionRtl">


                                        <div className="modal_order_grid_inner_col">
                                            <div className="modal_order_grid_inner_col_right_box">                                                
                                                <div className="modal_order_right_grid">
                                                    <div className="">
                                                        <div className="inner_middle_box" >
                                                            <div className="modal_order_left_grid_font2">
                                                                <span className="directionRtl">
                                                                {hotelForOrder.EndVacationDateFormatted}
                                                                -
                                                                {hotelForOrder.StartVacationDateFormatted}
                                                               
                                                                </span>
                                                            </div>
                                                            <div className="modal_order_left_grid_font2">
                                                                  לילות
                                                                 &nbsp;
                                                                {hotelForOrder.TotalNights}
                                                                &nbsp;
                                                                {hotelForOrder.WeekPeriodDescription}

                                                            </div>
                                                        </div>
                                                    </div>

                                                    <div className="">
                                                        <div className="inner_middle_box" >
                                                            <span className="modal_order_left_grid_font1">תאריכים</span>
                                                        </div>
                                                    </div>
                                                </div>                                                
                                                <div className="model_order_line2"></div>
                                                
                                                <div className="modal_order_right_grid">
                                                    <div className="">
                                                        <div className="inner_middle_box" >
                                                            <div className="modal_order_left_grid_font2">
                                                                    {placeOrderData.searchFieldGuests_placeholder}
                                                                </div>
                                                        </div>
                                                    </div>

                                                    <div className="">
                                                        <div className="inner_middle_box" >
                                                            <span className="modal_order_left_grid_font1">אורחים</span>
                                                        </div>
                                                    </div>
                                                </div>                                                
                                                <div className="model_order_line2"></div>

                                                <div className="modal_order_right_grid">
                                                    <div className="">
                                                        <div className="inner_middle_box" >
                                                            <div className="modal_order_left_grid_font2"> 
                                                                {hotelForOrder.RoomsNum}
                                                            </div>
                                                        </div>
                                                    </div>

                                                    <div className="">
                                                        <div className="inner_middle_box" >
                                                            <span className="modal_order_left_grid_font1">חדרים</span>
                                                        </div>
                                                    </div>
                                                </div>                                                
                                                <div className="model_order_line2"></div>
                                                
                                                <div className="modal_order_right_grid">
                                                    <div className="">
                                                        <div className="inner_middle_box" >
                                                            <div className="modal_order_left_grid_font2"> 
                                                            {hotelForOrder.HostBase}
                                                            </div>
                                                        </div>
                                                    </div>

                                                    <div className="">
                                                        <div className="inner_middle_box" >
                                                            <span className="modal_order_left_grid_font1 ">בסיס אירוח</span>
                                                        </div>
                                                    </div>
                                                </div>                                                
                                                <div className="model_order_line2"></div>


                                                {(hotelForOrder.NightsOnEmployee == 1) ?

                                                    <div className="marginTop10">
                                                        <div className="inner_middle_box" >
                                                            <span className="errorMsg">
                                                            שים לב! להזמנה קיים מחיר מיוחד
                                                            &nbsp;
                                                            *
                                                            </span>
                                                        </div>
                                                    </div>
                                                
                                                : null}

                                            </div>
                                        </div>


                                        <div className="modal_order_grid_inner_col_left" >

                                            <div className="modal_order_grid_inner_col_left_inner">
                                                <div className="modal_order_grid_font1">בקשות מיוחדות</div>
                                                <div>
                                                    אנו נשתדל למלא בקשות מיוחדות, אך לא נוכל להתחייב לכך.
                                                </div>
                                                <div>
                                                    <div className="check-form-group directionRtl">
                                                        <input 
                                                            type="checkbox" 
                                                            id="chk1"
                                                            checked={this.state.IsCouplingRooms}
                                                            onChange={this.CouplingRoomsChange} 
                                                        ></input>
                                                        <label htmlFor="chk1">חדרים צמודים</label>
                                                    </div>
                                            
                                                </div>
                                                <div>


                                                    <div className="check-form-group">
                                                        <input 
                                                            type="checkbox" 
                                                            id="chk2"
                                                            checked={this.state.HasConnectionDoor}
                                                            onChange={this.HasConnectionDoorChange} 
                                                        ></input>
                                                        <label htmlFor="chk2">דלת מקשרת </label>
                                                    </div>
                                                </div>
                                            </div>

                                            <div className="modal_order_grid_inner_col_left_inner marginTop10">
                                                <div className="modal_order_grid_font1">מדיניות ביטולים</div>
                                                <div>
                                                ניתן לבטל את ההזמנה עד שלושה שבועות לפני מועד ההזמנה.
                                                </div>
                                            </div>



                                            <div className="modal_order_grid_inner_col_left_inner marginTop10">
                                                <div className="modal_order_grid_font1">ספק  </div>
                                                <div>
                                                {hotelForOrder.SupplierName}
                                                </div>
                                            </div>

                                            <div>
                                            </div>

                                            
                                            <div>
                                                <div className="cntered-flex marginTop20">
                                                    <div className="hp_search_main_button directionRtl"
                                                            onClick={() => this.doOrder()}>

                                                        <span className="hp_search_main_button_title">
                                                        אישור הזמנה
                                                        </span>
                                                        
                                                        {(this.state.loading) ?
                                                            <span className="hp_search_main_button_title">
                                                                <Spinner
                                                                    as="span"
                                                                    animation="border"
                                                                    size="sm"
                                                                    role="status"
                                                                    aria-hidden="true"                                        
                                                                />      
                                                            </span>
                                                        : null}
                                                    </div>
                                                </div>
                                            </div>
                                        </div>


                                    </div> 
                                </div>
                            </div>
                        </div>
                    </div>                
                </React.Fragment>
            </div>
    );
  }
}



export default compose(
    withNofeshService(),    
  )(ModalOrder);
//export default ModalOrder;